import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient, getUseObservationLogsKey } from '@/hooks'
import { APIErrorResponse } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export type UseDeleteObservationLogProps = {
  id: number
}

export const useDeleteObservationLog = ({
  id,
}: UseDeleteObservationLogProps): UseMutationResult<
  unknown,
  APIErrorResponse,
  void
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const queryKey = getUseObservationLogsKey()

  return useMutation(
    () =>
      client
        .delete(`/plannings/observation_logs/${id}/`)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryKey)
      },
    }
  )
}
